
import externalConfiguration from '../external-configuration';

const urlBase = '//vdmit-163711.appspot.com/';
const urlTtl = '//vdmit-163711.appspot.com/timeToLoad';

export const testLoadAPI = () => {
  fetch( urlBase, { method: 'POST'}); // Contador de impresiones

  const iframeQueryString = `?location=${encodeURIComponent(window.location)}`;
  const iframeUrl = `${externalConfiguration.apiCDNDomain}${externalConfiguration.apiPublicPath}iframe/4916b1c1-a615-4130-895b-fe07f457c6f3${iframeQueryString}`;
  const init = new Date().getTime();
  fetch( iframeUrl).then( response => {
    const cacheHit = !!response.headers.get('X-Cache');
    // console.log( response.headers.get('X-Cache'));  // DEVELOP
    const headers = {
      'Content-Type': 'application/json',
    };
    const resp = new Date().getTime();
    const body = JSON.stringify({
      init, resp, miliseconds: resp - init, cacheHit,
    });
    fetch( urlTtl, { method: 'POST', body, headers}); // Contador de tiempo de carga
  });

}



// WEBPACK FOOTER //
// ./src/helpers/tests.js